export default __webpack_public_path__ + "media/a97e71345968ec131400aec5035bb07d22914d03c460eb70195ab31d62caad64.svg";